// v2.0 - Half Width Version

// v1.1 make it more like insta, titok home page with grid, reel, etc

// ok v1 init
import React from 'react';
import './CustomSlider-halfwidth.css'; // Importing the specific CSS file
import { FullWidthBgImage } from './FullWidthBgImage'; // Assuming this is needed
import CardIcon from './CardIcon'; // Import CardIcon

// Functional CustomSlider component - Half Width
const data = [ // Using the same data for now
    {
      title: "Milan",
      image:
        "https://cdn.theculturetrip.com/wp-content/uploads/2019/04/ia_0444_city-header_milan_marianna-tomaselli-768x432.jpg"
    },
    {
      title: "Hong Kong",
      image:
        "https://cdn.theculturetrip.com/wp-content/uploads/2019/04/ia_0378_hong-kong_jisu-choi_final_header-1-768x512.jpg"
    },
    {
      title: "Prague",
      image:
        "https://cdn.theculturetrip.com/wp-content/uploads/2019/04/location-page-header-prague-greta-samuel-768x512.jpg"
    },
    {
      title: "Florence",
      image:
        "https://cdn.theculturetrip.com/wp-content/uploads/2019/04/ia_0440_florence_giordano-poloni_final_header-768x512.jpg"
    },
    {
      title: "Venice",
      image:
        "https://cdn.theculturetrip.com/wp-content/uploads/2019/04/ia_0449_venice_marianna-tomaselli_final_header-768x432.jpg"
    },
    {
      title: "Los Angeles",
      image:
        "https://cdn.theculturetrip.com/wp-content/uploads/2019/04/venice-beach_final-768x512.jpg"
    },
    {
      title: "Milan",
      image:
        "https://cdn.theculturetrip.com/wp-content/uploads/2019/04/ia_0444_city-header_milan_marianna-tomaselli-768x432.jpg"
    },
    {
      title: "Hong Kong",
      image:
        "https://cdn.theculturetrip.com/wp-content/uploads/2019/04/ia_0378_hong-kong_jisu-choi_final_header-1-768x512.jpg"
    },
    {
      title: "Prague",
      image:
        "https://cdn.theculturetrip.com/wp-content/uploads/2019/04/location-page-header-prague-greta-samuel-768x512.jpg"
    },
    {
      title: "Florence",
      image:
        "https://cdn.theculturetrip.com/wp-content/uploads/2019/04/ia_0440_florence_giordano-poloni_final_header-768x512.jpg"
    },
    {
      title: "Venice",
      image:
        "https://cdn.theculturetrip.com/wp-content/uploads/2019/04/ia_0449_venice_marianna-tomaselli_final_header-768x432.jpg"
    },
    {
      title: "Los Angeles",
      image:
        "https://cdn.theculturetrip.com/wp-content/uploads/2019/04/venice-beach_final-768x512.jpg"
    }
  ];

const CustomSliderHalfwidth = () => {
  return (
    <div className="custom-slider-halfwidth">
      {data.map((item, index) => (
        <div
          key={index}
          className="bg-image-container-halfwidth"
          style={{
            backgroundImage: `url(${item.image})`,
            borderRadius: '10px',
            position: 'relative',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'flex-end',
            padding: '10px',
          }}
        >
          <CardIcon />
          <div className="slider-label-halfwidth">
            {'Category'}
          </div>
          <div className="slider-body-halfwidth">
            {item.title}
          </div>
        </div>
      ))}
    </div>
  );
};

export default CustomSliderHalfwidth;
